import * as React from "react";

function SvgIcons8AppleTv(props, ref) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 48 48" {...{ ...props, ref }}>
      <path
        fill="#455A64"
        d="M42 37a5 5 0 01-5 5H11a5 5 0 01-5-5V11a5 5 0 015-5h26a5 5 0 015 5v26z"
      />
      <path
        fill="#80D8FF"
        d="M15.869 18.839c.397-.458 1.033-.764 1.589-.839.08.61-.158 1.22-.476 1.603-.397.456-.954.762-1.589.762-.159-.534.08-1.069.476-1.526zm3.416 7.701c-.477.612-1.111 1.452-1.827 1.452-.714 0-.873-.459-1.747-.382-.953 0-1.111.457-1.826.382-.795 0-1.351-.688-1.748-1.374-1.191-1.754-1.35-3.891-.555-5.034.555-.764 1.35-1.22 2.144-1.22s1.351.456 1.985.456c.636 0 1.033-.456 1.986-.456.714 0 1.43.381 1.985.992-1.747.914-1.431 3.278.317 3.966-.316.534-.476.762-.714 1.218zM25.521 18v1.839h2.196V21h-2.196v4.279c0 .961.254 1.52 1.184 1.52.422 0 .675 0 .844-.08l.085 1.121c-.254.079-.761.16-1.353.16-.676 0-1.267-.24-1.689-.641-.422-.48-.592-1.119-.592-2.08V21h-1.268v-1.161H24V18.4l1.521-.4zm5.083 2l1.69 4.479c.254.722.508 1.361.676 2.08h.084c.17-.639.423-1.279.677-2.08L35.338 20h1.604l-3.294 8h-1.437L29 20h1.604z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8AppleTv);
